import { render } from "./GradeFields.vue?vue&type=template&id=7877b244&scoped=true&ts=true&lang=pug"
import script from "./GradeFields.vue?vue&type=script&lang=ts"
export * from "./GradeFields.vue?vue&type=script&lang=ts"

import "./GradeFields.vue?vue&type=style&index=0&id=7877b244&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7877b244"]])

export default __exports__